<div class="container-fluid">
  <div class="page-title flex">
    <h5 class="float-left">{{'SNMPv1 Profiles' | translate}}</h5>
    <div>
      <button pButton type="button" label="{{'Add' | translate}}" icon="fa fa-plus" class="ui-button-danger update" (click)="showsnmpv1AddDialog()"></button>
      <button pButton type="button" label="{{'Edit' | translate}}" icon="fa fa-pencil-square-o" [disabled]="(selectedsnmpv1Display == null)" class="ui-button-danger update"
      (click)="showsnmpv1EditDialog()"></button>
      <button pButton type="button" label="{{'Delete' | translate}}" icon="fa fa-trash" class="ui-button-danger" (click)="showsnmpv1DeleteDialog()" [disabled]="(selectedsnmpv1Display == null || snmpv1buttonDisabled)"></button>
    </div>
  </div>
  <p-table class="deviceTable pageAllOptions" [columns]="columns_cols" [value]="snmpv1List" [rows]="10" [paginator]="true" [rowsPerPageOptions]="[10,20,{showAll:'All'}]"
    [scrollable]="true" selectionMode="single" [(selection)]="selectedsnmpv1Display" (onRowSelect)="handlesnmpv1RowSelect($event)" [scrollable]="true">
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th *ngFor="let col of columns" [pSortableColumn]="col.field" [ngStyle]="{'width.px':(col.width) }" [ngClass]="col.class">
          {{col.header | translate}}
          <p-sortIcon [field]="col.field"></p-sortIcon>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns">
      <tr [pSelectableRow]="rowData">
        <td style="width:150px" class="col-nowrap">
          <span>{{rowData.vendorMibName}}</span>
        </td>
        <td style="width:200px" class="col-nowrap">{{rowData.profileName}}<span translate *ngIf="rowData.id === 0"> (Default)</span></td>
        <td style="width:200px" class="col-nowrap" *ngIf="isMsp">
          <span>{{rowData.company}}</span>
        </td>
        <!-- <td style="width:250px" class="col-nowrap">{{rowData.community}}</td>
        <td style="width:250px" class="col-nowrap">{{rowData.trapCommunity}}</td> -->
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td [attr.colspan]="columns_cols.length">
          <div translate class="ui-emptymessage">No Data found</div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
<div class="container-fluid" style="margin-top: 60px">
  <div class="page-title flex">
    <h5 class="float-left">{{'SNMPv3 Profiles' | translate}}</h5>
    <div>
      <button pButton type="button" label="{{'Add' | translate}}" icon="fa fa-plus" class="ui-button-danger update" (click)="showsnmpv3AddDialog()"></button>
      <button pButton type="button" label="{{'Edit' | translate}}" icon="fa fa-pencil-square-o" [disabled]="(selectedsnmpv3Display == null)" class="ui-button-danger update"
      (click)="showsnmpv3EditDialog()"></button>
      <button pButton type="button" label="{{'Delete' | translate}}" icon="fa fa-trash" class="ui-button-danger" (click)="showsnmpv3DeleteDialog()" [disabled]="(selectedsnmpv3Display == null || snmpv3buttonDisabled)"></button>
    </div>
  </div>
  <p-table class="deviceTable pageAllOptions" [columns]="snmpv3List_columns_cols" [value]="snmpv3List" [rows]="10" [paginator]="true" [rowsPerPageOptions]="[10,20,{showAll:'All'}]"
    [scrollable]="true" selectionMode="single" [(selection)]="selectedsnmpv3Display" (onRowSelect)="handlesnmpv3RowSelect($event)" [scrollable]="true">
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th *ngFor="let col of columns" [pSortableColumn]="col.field" [ngStyle]="{'width.px':(col.width) }" [ngClass]="col.class">
          {{col.header | translate}}
          <p-sortIcon [field]="col.field"></p-sortIcon>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns">
      <tr [pSelectableRow]="rowData">
        <td style="width:150px" class="col-nowrap">
          <span>{{rowData.vendorMibName}}</span>
        </td>
        <td style="width:200px" class="col-nowrap">{{rowData.profileName}}<span *ngIf="rowData.id === 0"> (Default)</span></td>
        <td style="width:200px" class="col-nowrap" *ngIf="isMsp">
          <span>{{rowData.company}}</span>
        </td>
        <!-- <td style="width:150px" class="col-nowrap">{{rowData.userName}}</td> -->
        <td style="width:250px" class="col-nowrap">
          <span>{{rowData.authProtocolStr}}</span>
        </td>
        <td style="width:200px" class="col-nowrap">
          <span>{{rowData.privacyProtocolStr}}</span>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td [attr.colspan]="snmpv3List_columns_cols.length">
          <div translate class="ui-emptymessage">No Data found</div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<!-- v1 -->
<p-dialog header="{{snmpv1DialogInput.UpdateType | translate}}" [(visible)]="displaysnmpv1Dialog" [modal]="true" [style]="{'width': '450px'}"[baseZIndex]="10000" class="gatewayDialog">
  <div class="dialog-content">
    <p-steps [(activeIndex)]="tabSnmpv1Index" [readonly]="true"></p-steps>
    <section *ngIf="tabSnmpv1Index === 0">
      <div class="form-group">
        <label translate>Vendor MIB</label>
        <div class="select">
          <p-select [options]="vendorMIBOption" [(ngModel)]="snmpv1DialogInput.vendorMib" [style]="{'width':'100%'}" [disabled]="this.snmpv1DialogInput.Id === 0">
            <ng-template pTemplate="item" let-item>
              {{item.label | translate}}
            </ng-template>
            <ng-template pTemplate="selectedItem" let-item>
              {{item.label | translate}}
            </ng-template>
          </p-select>
        </div>
      </div>
      <div class="form-group">
        <label translate>Profile Name</label>
        <input type="text" size="30" maxlength="30" class="form-control pInputText" [(ngModel)]="snmpv1DialogInput.profileName"  pInputText>
      </div>
      <div class="form-group">
        <label translate>SNMP Community</label>
        <input type="text" class="form-control pInputText password" [(ngModel)]="snmpv1DialogInput.community" pInputText (focus)="changeInputBox($event, 'Edit SNMPv1', 'community')">
      </div>
      <div class="form-group">
        <label translate>SNMP Trap Community</label>
        <input type="text" class="form-control pInputText password" [(ngModel)]="snmpv1DialogInput.trapCommunity" pInputText (focus)="changeInputBox($event, 'Edit SNMPv1', 'trapCommunity')">
      </div>
      <div class="form-group" *ngIf="isMsp">
        <label translate>Company</label>
        <div class="select">
          <p-select [options]="companyOptions" [(ngModel)]="snmpv1DialogInput.company" [style]="{'width':'100%'}" [disabled]="this.snmpv1DialogInput.UpdateType === 'Edit SNMPv1'">
            <ng-template pTemplate="item" let-item>
              {{item.label | translate}}
            </ng-template>
            <ng-template pTemplate="selectedItem" let-item>
              {{item.label | translate}}
            </ng-template>
          </p-select>
        </div>
      </div>
    </section>
    <section *ngIf="tabSnmpv1Index === 1">
      <div class="content-info">
        <p style="padding-bottom: 10px;" translate>The new configuration will be synchronized to the gateway that is using this profile.</p>
      </div>
      <ul class="alert alert-warning">
        <li *ngFor="let item of useGatewayList">
          <span class="title">{{item.name}}</span>
          <span class="capitalize">{{item.status}}</span>
        </li>
      </ul>
      <div class="content-info">
        <p style="padding-top: 10px;" translate>Please note that the gateway that is offline will be synchronized once it returns to online status.</p>
      </div>
    </section>
  </div>
  <ng-template #footer>
    <section *ngIf="tabSnmpv1Index === 0" class="grid">
      <button *ngIf="snmpv1DialogInput.UpdateType === 'Add SNMPv1'" type="button" pButton (click)="savesnmpv1Data();" label="{{'Save' | translate}}" class="ui-button-danger" [disabled]="
      snmpv1DialogInput.vendorMib === 0 || 
      snmpv1DialogInput.profileName === '' || snmpv1DialogInput.profileName === undefined || 
      snmpv1DialogInput.community === '' || snmpv1DialogInput.community === undefined || 
      snmpv1DialogInput.trapCommunity === '' || snmpv1DialogInput.trapCommunity === undefined || 
      (isMsp && snmpv1DialogInput.company === 0)"></button>
      <button *ngIf="snmpv1DialogInput.UpdateType === 'Edit SNMPv1'" type="button" pButton (click)="checksnmpv1GatewayUsing();" label="{{'Save' | translate}}" class="ui-button-danger" [disabled]="
      snmpv1DialogInput.vendorMib === 0 || 
      snmpv1DialogInput.profileName === '' || snmpv1DialogInput.profileName === undefined || 
      snmpv1DialogInput.community === '' || snmpv1DialogInput.community === undefined || 
      snmpv1DialogInput.trapCommunity === '' || snmpv1DialogInput.trapCommunity === undefined || 
      (isMsp && snmpv1DialogInput.company === 0)"></button>
      <button type="button" pButton (click)="displaysnmpv1Dialog=false;" label="{{'Cancel' | translate}}" class="p-button-secondary"></button>
    </section>
    <section *ngIf="tabSnmpv1Index === 1" class="grid">
      <button type="button" pButton (click)="checksnmpv1GatewayDiscovering();" label="{{'Save' | translate}}" class="ui-button-danger"></button>
      <button type="button" pButton (click)="displaysnmpv1Dialog=false;" label="{{'Cancel' | translate}}" class="p-button-secondary"></button>
    </section>
  </ng-template>
</p-dialog>

<!-- Confirm -->
<p-dialog header="{{'Confirm' | translate}}" [(visible)]="displaysnmpv1DeleteDialog" [modal]="true" [style]="{'width': '450px'}" [baseZIndex]="10000" class="ConfirmDialog">
  <div cla="page-content-body">
    <p translate>Are you sure you want to delete this profile?</p>
  </div>
  <ng-template #footer>
    <div class="page-content-btn">
      <button type="button" pButton label="{{'Confirm' | translate}}" class="ui-button-danger" (click)="deletesnmpv1Data()"></button>
      <button type="button" pButton (click)="displaysnmpv1DeleteDialog=false" label="{{'Cancel' | translate}}"class="p-button-secondary"></button>
    </div>
  </ng-template>
</p-dialog>

<!-- Warning -->
<p-dialog header="{{'Warning' | translate}}" [(visible)]="displayWarningDialog" [baseZIndex]="11000" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog setup" [closable]="false">
  <div class="dialog-content align-items-top">
    <div class="icon">
      <i class="fa fa-exclamation-circle warning"></i>
    </div>
    <div class="content-info">
      <p>{{warningStr | translate}}</p>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'OK' | translate}}" class="ui-button-danger" (click)="displayWarningDialog=false"></button>
  </ng-template>
</p-dialog>

<!-- v3 -->
<p-dialog header="{{snmpv3DialogInput.UpdateType | translate}}" [(visible)]="displaysnmpv3Dialog" [modal]="true" [style]="{'width': '450px'}"[baseZIndex]="10000" class="gatewayDialog accountSetting">
  <div class="dialog-content">
    <section *ngIf="tabSnmpv3Index === 0">
      <div class="form-group">
        <label translate>Vendor MIB</label>
        <div class="select">
          <p-select [options]="vendorMIBOption" [(ngModel)]="snmpv3DialogInput.vendorMib" [style]="{'width':'100%'}" (onChange)="onChangeSNMPv3DailogBox()" [disabled]="this.snmpv3DialogInput.Id === 0">
            <ng-template pTemplate="item" let-item>
              {{item.label | translate}}
            </ng-template>
            <ng-template pTemplate="selectedItem" let-item>
              {{item.label | translate}}
            </ng-template>
          </p-select>
        </div>
      </div>
      <div class="form-group">
        <label translate>Profile Name</label>
        <input type="text" size="30" maxlength="30" class="form-control pInputText" [(ngModel)]="snmpv3DialogInput.profileName" pInputText (input)="onChangeSNMPv3DailogBox()">
      </div>
      <div class="form-group">
        <label translate>User Name</label>
        <input type="text" size="30" maxlength="30" class="form-control pInputText password" [(ngModel)]="snmpv3DialogInput.userName" pInputText (input)="onChangeSNMPv3DailogBox()" (focus)="changeInputBox($event, 'Edit SNMPv3', 'userName')">
      </div>
      <div class="form-group">
        <label translate>Authentication Protocol</label>
        <div class="select">
          <p-select [options]="authenticationProtocolOption" [(ngModel)]="snmpv3DialogInput.authProtocol" [style]="{'width':'100%'}" (onChange)="onChangeSNMPv3DailogBox()" appendTo="body"></p-select>
        </div>
      </div>
      <div class="form-group">
        <label translate>Authentication Key</label>
        <input type="text" class="form-control pInputText password" [(ngModel)]="snmpv3DialogInput.authKey" pInputText (input)="onChangeSNMPv3DailogBox()" (focus)="changeInputBox($event, 'Edit SNMPv3', 'authKey')" [disabled]="snmpv3DialogInputFlag.authKey">
      </div>
      <div class="form-group">
        <label translate>Privacy Protocol</label>
        <div class="select">
          <p-select [options]="privacyProtocolOption" [(ngModel)]="snmpv3DialogInput.privacyProtocol" [style]="{'width':'100%'}" (onChange)="onChangeSNMPv3DailogBox()" [disabled]="snmpv3DialogInputFlag.privacyProtocol" appendTo="body"></p-select>
        </div>
      </div>
      <div class="form-group">
        <label translate>Privacy Key</label>
        <input type="text" class="form-control pInputText password" [(ngModel)]="snmpv3DialogInput.privacyKey" pInputText (input)="onChangeSNMPv3DailogBox()" (focus)="changeInputBox($event, 'Edit SNMPv3', 'privacyKey')" [disabled]="snmpv3DialogInputFlag.privacyKey">
      </div>
      <div class="form-group" *ngIf="isMsp">
        <label translate>Company</label>
        <div class="select">
          <p-select [options]="companyOptions" [(ngModel)]="snmpv3DialogInput.company" [style]="{'width':'100%'}" (onChange)="onChangeSNMPv3DailogBox()" [disabled]="this.snmpv3DialogInput.UpdateType === 'Edit SNMPv3'" appendTo="body">
            <ng-template pTemplate="item" let-item>
              {{item.label | translate}}
            </ng-template>
            <ng-template pTemplate="selectedItem" let-item>
              {{item.label | translate}}
            </ng-template>
          </p-select>
        </div>
      </div>
    </section>
    <section *ngIf="tabSnmpv3Index === 1">
      <div class="content-info">
        <p style="padding-bottom: 10px;" translate>The new configuration will be synchronized to the gateway that is using this profile.</p>
      </div>
      <ul class="alert alert-warning">
        <li *ngFor="let item of useGatewayList">
          <span class="title">{{item.name}}</span>
          <span class="capitalize">{{item.status}}</span>
        </li>
      </ul>
      <div class="content-info">
        <p style="padding-top: 10px;" translate>Please note that the gateway that is offline will be synchronized once it returns to online status.</p>
      </div>
    </section>
  </div>
  <ng-template #footer>
    <section *ngIf="tabSnmpv3Index === 0" class="grid">
      <button *ngIf="snmpv3DialogInput.UpdateType === 'Add SNMPv3'" type="button" pButton (click)="savesnmpv3Data();" label="{{'Add' | translate}}" class="ui-button-danger" [disabled]="snmpv3DialogInputFlag.disableSaveFlag"></button>
      <button *ngIf="snmpv3DialogInput.UpdateType === 'Edit SNMPv3'" type="button" pButton (click)="checksnmpv3GatewayUsing();" label="{{'Save' | translate}}" class="ui-button-danger" [disabled]="snmpv3DialogInputFlag.disableSaveFlag"></button>
      <button type="button" pButton (click)="displaysnmpv3Dialog=false;" label="{{'Cancel' | translate}}" class="p-button-secondary"></button>
    </section>
    <section *ngIf="tabSnmpv3Index === 1" class="grid">
      <button type="button" pButton (click)="checksnmpv3GatewayDiscovering();" label="{{'Save' | translate}}" class="ui-button-danger"></button>
      <button type="button" pButton (click)="displaysnmpv3Dialog=false;" label="{{'Cancel' | translate}}" class="p-button-secondary"></button>
    </section>
  </ng-template>
</p-dialog>

<!-- Confirm -->
<p-dialog header="{{'Confirm' | translate}}" [(visible)]="displaysnmpv3DeleteDialog" [modal]="true" [style]="{'width': '450px'}" [baseZIndex]="10000" class="ConfirmDialog">
  <div cla="page-content-body">
    <p translate>Are you sure you want to delete this profile?</p>
  </div>
  <ng-template #footer>
    <div class="page-content-btn">
      <button type="button" pButton label="{{'Confirm' | translate}}" class="ui-button-danger"(click)="deletesnmpv3Data()"></button>
      <button type="button" pButton (click)="displaysnmpv3DeleteDialog=false" label="{{'Cancel' | translate}}"class="p-button-secondary"></button>
    </div>
  </ng-template>
</p-dialog>

<!-- Confirm Discovery -->
<p-dialog header="{{'Confirm' | translate}}" [(visible)]="displaySnmpDeleteDiscoveryDialog" [modal]="true" [style]="{'width': '450px'}" [baseZIndex]="10000" class="ConfirmDialog">
  <div cla="page-content-body">
    <p translate>This profile has already been added to the discovery job and cannot be deleted.</p>
  </div>
  <ng-template #footer>
    <div class="page-content-btn">
      <!-- <button type="button" pButton label="{{'Confirm' | translate}}" class="ui-button-danger"(click)="deletesnmpv3Data()"></button> -->
      <button type="button" pButton (click)="displaySnmpDeleteDiscoveryDialog=false" label="{{'Cancel' | translate}}"class="p-button-secondary"></button>
    </div>
  </ng-template>
</p-dialog>
